export const STORAGE_KEYS = {
    STATE: 'state',
    ACCESS_TOKEN: 'accessToken',
    REFRESH_TOKEN: 'refreshToken',
    ID_TOKEN: 'idToken',
    METADATA_TOKEN: 'metadataToken',
    EW_JWT_TOKEN:'ew_jwt_token'
} as const;
  
class StorageService {
    static setItem(key: string, value: string): void {
      try {
        localStorage.setItem(key, value);
      } catch (error) {
        console.error(`Failed to set ${key} in localStorage:`, error);
      }
    }
  
    static getItem(key: string): string | null {
      try {
        return localStorage.getItem(key);
      } catch (error) {
        console.error(`Failed to get ${key} from localStorage:`, error);
        return null;
      }
    }
  
    static removeItem(key: string): void {
      try {
        localStorage.removeItem(key);
      } catch (error) {
        console.error(`Failed to remove ${key} from localStorage:`, error);
      }
    }
  
    static clear(): void {
      try {
        localStorage.clear();
      } catch (error) {
        console.error('Failed to clear localStorage:', error);
      }
    }
}
  
export default StorageService;